export enum ReceiptLabelText {
  DateAndTime = 'Date and Time',
  SessionType = 'Session Type',
  SessionLocation = 'Session Location',
  AccessDetails = 'Access Details',
  Duration = 'Duration',
  Reason = 'Reason',
  Stylist = 'Stylist',
  Aesthetics = 'Aesthetics',
  PriceTier = 'Price Tier',
  PromoCode = 'Promo Code',
  PaymentMethod = 'Payment Method',
  TotalPriceEstimated = 'Total Price Estimated:',
  Product = 'Product',
}
